import { Col, Row, Space } from "antd";
import { format, getMonth } from "date-fns";
import { lastDayOfMonth } from "date-fns/fp";
import React, { useEffect, useState } from "react";

const isEqual = (a, b) =>
  a.length === b.length &&
  a.every((value, index) => value === b[index]);

const firstDateOfMonth = (date) => format(date, 'yyyy-MM-01');
const lastDateOfMonth = (date) => format(lastDayOfMonth(date), 'yyyy-MM-dd');
const months = Array.from({length: 12}, (item, i) => {
  const date = new Date();
  date.setMonth(date.getMonth() + i);
  
  const month = format(date, 'MMMM');
  const year = format(date, 'yyyy');

  return {
    value: i,
    date: [firstDateOfMonth(date), lastDateOfMonth(date)],
    month, year
  }
});


function FilterPills(
  props: {
    items?:any[];
    itemsHeader?:string;
    locations?:any[];
    locationsHeader?:string;
    initialValue:{keyword?:string, year?:any, months?: any, location_id?:any, type?: any}
    bindLabel:string;
    bindValue:string;
    allOption:boolean;
    disableMonths:boolean;
    selectFilter;
  }){
  
  const { items, locations, itemsHeader, locationsHeader, bindLabel, bindValue, initialValue, allOption } = props;

  const [selected, setSelected] = useState(initialValue);

  useEffect(() => {
    setSelected(initialValue)
  }, [initialValue]);

  const allHasValues = () => {
    const {keyword, ...noKeyword} = selected;
    return Object.entries(noKeyword).every(o => o[1] != "" && o[1] != null);
  }
  const [collapseFilters, setcollapseFilters] = useState(allHasValues);
  
  const selectFilter = (label, value) => {
    selected[label] = value;

    setSelected(selected);
  
    // setcollapseFilters(allHasValues);

    props.selectFilter(selected);
  }


  const selectLocation = (location) => {
    selected["location_id"] = location.id;
    selected["keyword"] = location.name;
    setSelected(selected);
    props.selectFilter(selected, true);
  }

  return (
    <Space size={12} direction="vertical">
      {
        items && (
          <>
            { itemsHeader && <div className="filter-title"> {itemsHeader} </div> }
            <Space size={10} wrap>
                {
                  allOption && <div onClick={()=>selectFilter(bindValue, '')} className={`filter-pill ${(selected[bindValue] == null || selected[bindValue] == '') && 'selected'}`}> <span> All </span></div>
                }
                {
                  items.map((item, index) => {
                    const id:any = bindValue || "id";
                    const value = bindValue ? item[id] : item;
                    const selectedItem = selected && bindValue ? selected[bindValue]: item ;
                    return <div key={index} onClick={()=>selectFilter(bindValue, value)} className={`filter-pill ${selectedItem == value && 'selected'}`}> <span>{ item[bindLabel] } </span></div>
                  })
                }
            </Space>
          </>
        )
      }
      {
        locations && (
          <>
            { locationsHeader && <div className="filter-title"> {locationsHeader} </div> }
            <Space size={10} wrap>
                {
                  allOption && <div onClick={()=>selectFilter(bindValue, '')} className={`filter-pill ${(selected[bindValue] == null || selected[bindValue] == '') && 'selected'}`}> <span> All </span></div>
                }
                {
                  locations.map((item, index) => {
                    var isSelected = false;
                    if(selected){
                      isSelected = selected.location_id == item.id  || selected.keyword?.toLowerCase() == item[bindLabel].toLowerCase()
                    }
                    return <div key={index} onClick={()=>selectLocation(item)} className={`filter-pill ${isSelected && 'selected'}`}> <span>{ item[bindLabel] } </span></div>
                  })
                }
            </Space>
          </>
        )
      }

      <div className="filter-title"> Month Year </div>
      <Row gutter={[10, 10]} justify="space-between">
        {
          allOption && <div onClick={()=>selectFilter("months", null)} className={`filter-pill ${selected.months == null && 'selected'}`}> <span> All </span></div>
        }
        {
          months.map((month, index) =>{
            let isSelected = false;
            if(selected){
              if(selected.months){
                const selectedDate = selected?.months;
                isSelected = isEqual(month.date, selectedDate);
              }
            }
            return  <Col key={index} xs={8} md={6} lg={4}> 
              <div 
                onClick={()=> selectFilter("months", month.date) } 
                className={`filter-pill default-filter month-year ${isSelected && 'selected'}`}>
                  <span>{month.month} </span>
                  <span>{month.year} </span>
              </div> 
            </Col>
          })
        }
      </Row>
    </Space>
  )
  
}

FilterPills.defaultProps = {
  allOption: false,
  bindLabel: "label",
  bindValue: "keyword",
  disableMonths: true
}

export default FilterPills;